import { useAppContext } from '../../context/AppContext';
import { updateUserProfile } from '../../services';
import React, { useState, useEffect } from 'react';

export const ProfileSettings = () => {
  const { user, setUser, token, base_url, showStatus } = useAppContext();
  const [loading, setLoading] = useState(false);
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [formData, setFormData] = useState({
    fname: '',
    lname: '',
    email: ''
  });

  useEffect(() => {
    if (user) {
      setFormData({
        fname: user.fname || '',
        lname: user.lname || '',
        email: user.email || ''
      });
    }
  }, [user]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({ ...prev, [name]: value }));
  };

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await updateUserProfile(token, base_url, {
        fname: formData.fname,
        lname: formData.lname
      });
      setUser(response.user);
      showStatus('success', 'Profile updated successfully!');
    } catch (error) {
      showStatus('error', error.message || 'Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      showStatus('error', 'New passwords do not match');
      return;
    }
    if (passwordData.newPassword.length < 6) {
      showStatus('error', 'Password must be at least 6 characters long');
      return;
    }

    setLoading(true);
    try {
      await updateUserProfile(token, base_url, {
        old_password: passwordData.currentPassword,
        password: passwordData.newPassword,
        confirm_password: passwordData.confirmPassword
      });
      setIsChangingPassword(false);
      setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      showStatus('success', 'Password changed successfully!');
    } catch (error) {
      showStatus('error', error.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return <p className="form-hint">Loading user information…</p>;
  }

  return (
    <div>
      <div className="form-section">
        <h3 className="form-section-title">Profile</h3>
        <form onSubmit={handleSaveProfile}>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label" htmlFor="fname">First name</label>
              <input
                type="text"
                id="fname"
                name="fname"
                className="form-input"
                value={formData.fname}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="lname">Last name</label>
              <input
                type="text"
                id="lname"
                name="lname"
                className="form-input"
                value={formData.lname}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-input"
              value={formData.email}
              disabled
            />
            <p className="form-hint">Email address cannot be changed.</p>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Saving…' : 'Save Profile'}
          </button>
        </form>
      </div>

      <div className="form-section" style={{ marginTop: '32px' }}>
        <h3 className="form-section-title">Password</h3>
        {!isChangingPassword ? (
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setIsChangingPassword(true)}
          >
            Change Password
          </button>
        ) : (
          <form onSubmit={handleChangePassword}>
            <div className="form-group">
              <label className="form-label" htmlFor="currentPassword">Current password</label>
              <input
                type="password"
                id="currentPassword"
                name="currentPassword"
                className="form-input"
                value={passwordData.currentPassword}
                onChange={handlePasswordChange}
              />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="newPassword">New password</label>
              <input
                type="password"
                id="newPassword"
                name="newPassword"
                className="form-input"
                value={passwordData.newPassword}
                onChange={handlePasswordChange}
              />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="confirmPassword">Confirm new password</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                className="form-input"
                value={passwordData.confirmPassword}
                onChange={handlePasswordChange}
              />
            </div>
            <div className="step-nav">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setIsChangingPassword(false);
                  setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
                }}
                disabled={loading}
              >
                Cancel
              </button>
              <div className="step-nav-right">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Changing…' : 'Change Password'}
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};
